const styles = theme => ({
  // ..... Initator Flow Layout Styles ..... //
  container: {
    maxWidth: '1184px',
  },

  fontWeight600: {
    fontWeight: '600',
  },

  copyRightEvent: {
    cursor: 'pointer',
  },

  flowContentContainer: {
    [theme.breakpoints.up('sm')]: {
      minHeight: 'max-content',
      marginBottom: '100px',
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: '68px',
    },
  },

  flowActionsContainer: {
    [theme.breakpoints.up('sm')]: {
      boxShadow: '0px -1px 8px rgba(0, 0, 0, 0.1)',
      position: 'absolute',
      bottom: '0',
      left: '0px',
      marginTop: '16px',
      padding: '16px',
      background: 'white',
    },
  },

  actionsWrapper: {
    [theme.breakpoints.up('sm')]: {
      padding: '0px 24px',
    },
  },

  serviceid: {},
  breadcrumbsHolder: {
    margin: '12px 0px',
    display: 'flex',
    '& $serviceid': {
      marginLeft: 'auto',
      color: '#8C9099',
      fontSize: '14px',
      '& strong': {
        fontWeight: '600',
      },
    },
  },

  mobileTitlehead: {
    display: 'block',
    '& > div': {
      padding: '10px 15px',
    },
    '& a': {
      color: '#342D3D',
      padding: '7px 0',
      fontWeight: '500',
      display: 'block',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
      },
      '& img': {
        marginRight: '13px',
      },
    },
    '& $grayArea': {
      background: '#F8F8F8',
      color: '#8C9099',
      '& p': {
        fontSize: '12px',
      },
    },
  },

  '@media (min-width:768px)': {
    mobileTitlehead: {
      display: 'none',
    },
  },

  // ..... Return Flow Layout Styles ..... //
  Title: {
    fontWeight: '600',
    marginBottom: '5px',
    fontSize: '28px',
  },
  subTitle: {
    fontWeight: '600',
    fontSize: '18px',
  },
  chip: {
    marginLeft: '5px',
  },
  darkgreen: {
    color: '#fff',
    background: '#1C999B',
  },
  warning: {
    color: theme.palette.primary.warningMango,
    border: `1px solid ${theme.palette.primary.warningMango}`,
    background: theme.palette.primary.warningMangoLight,
  },

  propertyHeaderContainer: {
    display: 'grid',
    gridTemplateColumns: '61px auto',
    gap: '9px',
    '& img': {
      display: 'block',
      width: '100%',
    },
  },

  btn: {
    height: '58px',
    padding: '16px 30px',
    borderRadius: '4px',
    width: '100%',
    '& span': {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '24px',
      textTransform: 'capitalize',
    },
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      '& span': {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '21px',
      },
    },
  },

  primaryButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.white,

    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.white,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.white,
    },
  },

  secondaryButton: {
    backgroundColor: theme.palette.primary.white,
    color: theme.palette.primary.adgmBlack,
    border: `1px solid ${theme.palette.primary.adgmBlack}`,

    '&:hover': {
      backgroundColor: theme.palette.primary.white,
      color: theme.palette.primary.adgmBlack,
      border: `1px solid ${theme.palette.primary.adgmBlack}`,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.white,
      color: theme.palette.primary.adgmBlack,
      border: `1px solid ${theme.palette.primary.adgmBlack}`,
    },
  },
});

export default styles;
